export const PATH = '/purchase-orders';
